export default __webpack_public_path__ + "static/media/SurfaceAudio.70d837b7.svg";